interface ParlorBreadcrumbProps {
  sidoName: string;
  sigunguName: string;
  companyName: string;
}

export const ParlorBreadcrumb = ({
  sidoName,
  sigunguName,
  companyName,
}: ParlorBreadcrumbProps) => {
  return (
    <nav className="pd-breadcrumb" aria-label="현재 위치">
      <ol>
        <li>
          <span>홈</span>
        </li>
        <li>
          <span>지역별 장례식장</span>
        </li>
        <li>
          <span>{sidoName}</span>
        </li>
        <li>
          <span>{sigunguName}</span>
        </li>
        <li aria-current="page">{companyName}</li>
      </ol>
    </nav>
  );
};
